<template>
  <div class="fixed top-0 right-0 z-50 w-16 h-16" @dblclick="close" />
</template>

<script>
export default {
  name: 'CloseButton',
  methods: {
    close () {
      window.close()
    },
  },
}
</script>
